export default {
  termsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '-20px',
    flexDirection: 'row'
  },
  term: {
    position: 'relative',
    backgroundColor: 'rgb(68, 84, 97)',
    marginRight: '10px',
    fontWeight: '600',
    marginLeft: '3px',
    color: 'white',
    display:'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '5px 8px',
    borderRadius: '3px',
    fontSize: '13px'
  },
  icon: {
    height:'15px',
    color: 'white',
    cursor: 'pointer',
    marginLeft: '7px'
  },
  label: {
    display: 'flex',
    // zIndex: '21',
    flexDirection: 'column',
    marginBottom:'10px',
    marginRight: '18px',
    flexWrap: 'wrap'
  },
  labelHeading: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#000',
    fontWeight: '600',
    fontSize: '12px',
    marginTop: '2px',
    marginBottom: '5px'
  },
  filterContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  wrapStyle: {
    zIndex: 5000,
    background: 'none',
    boxShadow: 'none',
    borderBottom: 'none',
    transform: 'translateY(-50%)',
    maxWidth: '500px',
    left: '50%',
    top: '50%',
    overflowY: 'visible',
    marginRight: 0
  },
}
